export const ExperienceData = [
    {
        id: 1001,
        title: "Frontend Developer",
        institute: "Code's Thinker",
        duration: "2024 (3 months)",
        result: "Intern",
        description: "Focused on building dynamic and responsive user interfaces using React.js, optimized performance, and ensured a seamless user experience across web platforms."
    },
    {
        id: 1002,
        title: "Backend Developer",
        institute: "Code's Thinker",
        duration: "2024 - Present",
        result: "Intern",
        description: "Currently developing scalable server-side applications, building RESTful APIs, and managing databases with MongoDB for high-performance web apps."
    }
]

export const MachineLearningExperienceData = [
    {
        id: 1001,
        title: "Machine Learning Enthusiast",
        institute: "Self-Driven Learning",
        duration: "2024 - Present",
        result: "Ongoing",
        description: "Learning machine learning algorithms like regression, classification, clustering with hands-on experience in Python and TensorFlow."
    },
    {
        id: 1002,
        title: "Personal Projects (Movie Recommendation)",
        institute: "Self-Initiated",
        duration: "2024",
        result: "Completed",
        description: "Built a movie recommendation system using collaborative filtering techniques. Utilized Python, Pandas, NumPy, and machine learning libraries."
    }
]



